export const fetchReasonTitle = (
  reason: {
    reason: {
      ervkUuid: string;
      title: string;
      type: {
        name: string;
        title?: string;
      };
    };
  },
  isErpPm?: boolean,
): string => {
  if (isErpPm) {
    return reason.reason.type.title ?? reason.reason.title;
  }
  return reason.reason.ervkUuid ? reason.reason.title : reason.reason.type.name;
};
